'use client';

import { lazy, Suspense, useState } from 'react';
import { Search } from 'lucide-react';
import type { TourSearchCategory } from '../../utils/tour-search';
import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

const TourSearchContent = lazy(() =>
  import('./tour-search-content').then(module => ({ default: module.TourSearchContent })),
);

export function TourSearchDrawer({
  categories,
  mobile = false,
}: {
  categories: TourSearchCategory[];
  mobile?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [session, setSession] = useState(0);
  const { t } = useTranslations();
  return (
    <SearchDrawer
      open={open}
      onOpenChange={next => {
        if (next) setSession(value => value + 1);
        setOpen(next);
      }}
      trigger={
        mobile ? (
          <Button
            variant="outline"
            className="h-10 w-full !justify-start !gap-1 space-x-0 whitespace-nowrap rounded-[8px] px-[7px] text-[11px] text-primary min-[360px]:text-xs min-[380px]:text-sm"
          >
            <Search className="h-4 w-4 shrink-0 min-[360px]:h-5 min-[360px]:w-5" aria-hidden />
            <span className="min-w-0 flex-1 text-center">{t('text3304')}</span>
          </Button>
        ) : (
          <button
            type="button"
            aria-label="Otvoriť vyhľadávanie"
            className="flex h-12 w-12 items-center justify-center rounded-[16px] border border-border text-primary transition-colors hover:bg-primary hover:text-white"
          >
            <Search className="h-5 w-5" aria-hidden />
          </button>
        )
      }
    >
      <Suspense
        fallback={
          <div className="flex min-h-40 items-center justify-center" role="status">
            {t('text3304')}…
          </div>
        }
      >
        <TourSearchContent
          key={session}
          categories={categories}
          active={open}
          onClose={() => setOpen(false)}
        />
      </Suspense>
    </SearchDrawer>
  );
}
